import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="text-[8rem] md:text-[12rem] font-black text-background-200 select-none leading-none mb-4">
          404
        </div>
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-800 mb-2">
          页面未找到
        </h1>
        <p className="text-foreground-400 text-sm mb-1 font-mono">
          {location.pathname}
        </p>
        <p className="text-foreground-500 text-sm md:text-base mb-8">
          抱歉，您访问的页面不存在或已被移除
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="px-6 py-2.5 border border-foreground-200 hover:border-foreground-400 text-foreground-600 font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap"
          >
            浏览漫画
          </Link>
        </div>
      </div>
    </div>
  );
}